import { RequestParams, ResponseCatalog } from 'Models'
import { News, NewsStats } from 'Modules'
import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { Id } from 'Src/types/aliases'

export const newsApi = {
	getAll: async (requestParams: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<News>>(urls.root.dashboard.news, {
			params: requestParams,
		})
		return res.data
	},
	createOne: async (news: News) => {
		const res = await axiosDS().post<News>(urls.root.dashboard.news, { data: news })
		return res.data
	},
	updateOne: async (news: News, id: Id) => {
		const res = await axiosDS().patch(`${urls.root.dashboard.news}/${id}`, { data: news })
		return res.data
	},
	readOne: async (id: Id) => {
		const res = await axiosDS().patch<News>(`${urls.root.dashboard.news}/${id}/read`)
		return res.data
	},
	deleteOne: async (id: Id) => {
		const res = await axiosDS().delete(`${urls.root.dashboard.news}/${id}`)
		return res.data
	},
	getNewsAttach: async (filename: string, newsId: Id) => {
		const res = await axiosDS().get(`${urls.root.dashboard.document}/${newsId}/${filename}`, {
			responseType: 'blob',
		})
		return res.data
	},
	sendNewsAttach: async (file: File, id: Id) => {
		const data = new FormData()
		data.append('[data][file]', file)
		data.append('[data][news_id]', `${id}`)
		const res = await axiosDS().post(urls.root.dashboard.document, data)
		return res.data
	},
	deleteNewsAttach: async (id: Id) => {
		const res = await axiosDS().delete(`${urls.root.dashboard.document}/${id}`)
		return res.data
	},
	getStats: async () => {
		const res = await axiosDS().get<NewsStats>(urls.root.dashboard.stats)
		return res.data
	},
}
